module.exports = __webpack_public_path__ + "static/img/4.3b6aa17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/q_and_a/4.png
// module id = qqza
// module chunks = 0